import React from "react";
import { TListingValuationActionFormIO } from "../../../../domain/codecs/formIO/ListingValuationActionFormIO";
import { Background } from "../BuildingBlocks/Background";
import { Text } from "../BuildingBlocks/Text";
import { SpacingColumn } from "../BuildingBlocks/SpacingColumn";
import { CRMSpacing } from "../../models/CRMSpacing";
import { CRMColors } from "../../models/CRMColors";
import { CRMFontSizes } from "../../models/CRMFontSizes";
import { WeightBold } from "../WeightBold/WeightBold";

export const CRMValuationActionResult = (props: {
    form: TListingValuationActionFormIO;
}): JSX.Element => {
    const { form } = props;

    if (form.status === "submitting") {
        return (
            <Background color={CRMColors.NEUTRAL_12} padding={`${CRMSpacing.SMALL} ${CRMSpacing.MEDIUM}`} borderRadius="3px">
                <Text size={CRMFontSizes.SMALL} color={CRMColors.NEUTRAL_2}>Working…</Text>
            </Background>
        );
    }

    if (form.status === "failure" || form.status === "validationError") {
        return (
            <Background
                color={CRMColors.HIGHLIGHTS_INSTRUCTIONAL_BRICK_12}
                padding={`${CRMSpacing.SMALL} ${CRMSpacing.MEDIUM}`}
                borderRadius="3px"
            >
                <SpacingColumn spacing={CRMSpacing.TINY}>
                    <Text size={CRMFontSizes.SMALL}><WeightBold>That didn&apos;t work</WeightBold></Text>
                    <Text size={CRMFontSizes.X_SMALL} color={CRMColors.NEUTRAL_2}>
                        Nothing was changed. Try again, and if it keeps happening the
                        listing may be missing something this needs.
                    </Text>
                </SpacingColumn>
            </Background>
        );
    }

    if (form.status !== "success" || form.output.outcome === "") {
        return <></>;
    }

    return (
        <Background
            color={form.output.blocked
                ? CRMColors.HIGHLIGHTS_PERTINENT_YELLOW_12
                : CRMColors.HIGHLIGHTS_POSITIVE_GREEN_12
            }
            padding={`${CRMSpacing.SMALL} ${CRMSpacing.MEDIUM}`}
            borderRadius="3px"
        >
            <Text size={CRMFontSizes.SMALL} color={CRMColors.NEUTRAL_2}>
                {form.output.outcome}
            </Text>
        </Background>
    );
};
